const MULTIPLIER = 1664525;
const INCREMENT = 1013904223;
const MOD = 2 ** 32;

export type LcgRng = {
  readonly state: number;
  nextRandom: () => number;
};

export function createLcg(initialState: number): LcgRng {
  let state = initialState >>> 0;

  return {
    get state() {
      return state;
    },
    nextRandom() {
      state = (Math.imul(state, MULTIPLIER) + INCREMENT) >>> 0;
      return state / MOD;
    },
  };
}

export function advanceLcg(state: number): { state: number; value: number } {
  const next = (Math.imul(state >>> 0, MULTIPLIER) + INCREMENT) >>> 0;
  return { state: next, value: next / MOD };
}
